import React, { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { formatPrice } from '../utils/helpers';
import { getFormattedDuration } from 'utils/date';
import { featureAvailable } from '../services/features-service';

import DropdownElement from './dropdown-element';

import IconArrowDown from '../icons/icon-arrow-down';

class BudgetField extends PureComponent {
    static defaultProps = {
        trackedTime: 1 * 1000 * 60 * 60
    };

    state = {
        trackingType: this.props.trackingType || this.dropdownItems[0].id,
        costPerHour: this.props.costPerHour
    }

    handleCostPerHourChange = event => {
        const costPerHour = event.target.value - 0;

        this.setState({
            costPerHour: event.target.value === '' ? '' : costPerHour
        });

        this.props.onCostPerHourChange && this.props.onCostPerHourChange(costPerHour);
    }

    handleTrackingTypeChange = ({ id }) => {
        this.setState({
            trackingType: id
        });

        this.props.onTrackingTypeChange && this.props.onTrackingTypeChange(id);
    }

    get dropdownItems() {
        const { t } = this.props;
        const items = [];

        if (featureAvailable('timeTracking') && this.props.autoTracking) {
            items.push({
                id: 'auto',
                text: t('time-tracking:Tracked Time')
            });
        }

        items.push({
            id: 'manual',
            text: t('types.budget.manualEntry')
        });

        return items;
    }

    get trackingTypeElement() {
        const { t } = this.props;

        if (this.state.trackingType === 'auto') {
            return <React.Fragment><strong>{getFormattedDuration(this.props.trackedTime)}</strong>&nbsp;hours spent</React.Fragment>;
        }

        return t('types.budget.manualEntry');
    }

    get amount() {
        const trackedTime = this.state.trackingType === 'auto' ? this.props.trackedTime / 1000 / 60 / 60 : 0;

        return formatPrice(trackedTime * this.state.costPerHour || 0);
    }

    componentDidMount() {
        this.props.onTrackingTypeChange && this.props.onTrackingTypeChange(this.state.trackingType);
    }

    render() {
        return (
            <div className="field-holder budget-field">
                <div className="field-label dark">
                    <Trans i18nKey="fields:types.budget.timeCostAmount"
                        components={{
                            ColLarge: <div className="field-col large" />,
                            Col: <div className="field-col" />
                        }}
                    />
                </div>

                <div className="field field-default">
                    <div className="field-col large">
                        {
                            this.dropdownItems.length > 1 ? (
                                <DropdownElement items={this.dropdownItems} onItemClick={this.handleTrackingTypeChange} xAlign="left">
                                    <div className="dropdown-value">
                                        { this.trackingTypeElement }

                                        <IconArrowDown />
                                    </div>
                                </DropdownElement>
                            ) : this.trackingTypeElement
                        }
                    </div>

                    <div className="field-col">
                        <div className="field-input-holder">
                            <strong>$</strong> <input type="number" className="field-input" value={this.state.costPerHour} placeholder="0" onChange={this.handleCostPerHourChange} />
                        </div>
                    </div>

                    <div className="field-col">
                        <strong>${this.amount}</strong>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation(['fields', 'time-tracking'])(BudgetField);
